import React from 'react';
import { Switch, Route } from 'react-router-dom';
import EmargementList from './emargement-list';
import EmargementForms from './emargement-forms';
import { paths } from '../../../routes';

const Emargement = () => (
  <Switch>
    <Route path={paths.emargement.path} exact>
      <EmargementList />
    </Route>
    <Route path={paths.newEmargement.path}>
      <EmargementForms />
    </Route>
    <Route path={`${paths.emargement.path}/:emargementId`}>
      <EmargementForms />
    </Route>
  </Switch>
);

export default Emargement;
